import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { MenuItem } from '../../model/menu.model';
import { SegurosApiService } from '../../services/api/seguros-api.service';
import { CaHeaderComponent } from '@global-front-components/ui/header';
import { CaMenuComponent, CaMenuDirective, CaMenuItemComponent } from '@global-front-components/ui/menu';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { UsuarioConectadoComponent } from '../usuario-conectado/usuario-conectado.component';
import html2canvas from 'html2canvas';
import { AuthStoreService } from '../../services/store/auth-store.service';
import { UsuarioConectado } from '../../model/auth.model';

const BASE_LOGO_PATH = '../assets/images/';
const DEFAULT_LOGO = 'logo.png';

@Component({
	selector: 'app-header',
	standalone: true,
	imports: [
		CommonModule,
		CaHeaderComponent,
		CaMenuComponent, 
		CaMenuDirective, 
		CaMenuItemComponent,
		UsuarioConectadoComponent,
		TranslateModule		
	],
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit{
	mostrarHeader = true;
	menuItems!: MenuItem[];
	pathLogo: string = BASE_LOGO_PATH + DEFAULT_LOGO;
	usuario: UsuarioConectado;
	
	constructor(
		private segurosService: SegurosApiService, 
		private authStoreService: AuthStoreService,		    
		private router: Router
	){}

	ngOnInit(): void {
		this.segurosService.getMenuPrivado().subscribe(menuItems => {
			this.menuItems = menuItems;
		});
		this.authStoreService.getUsuarioConectado()
			.subscribe(user => {
				this.usuario = user;
				if (this.usuario?.tema !== null && this.usuario?.tema !== undefined) {
					this.cargarTema(this.usuario.tema);
				}
			});
	}

	clickMenuItem(ruta) {
		if (ruta){
			this.router.navigate([ruta]);	
		}
	}

	public cargarTema(tema: string) {
		const logoTema = `${BASE_LOGO_PATH}${tema}.png`;

		// Cargamos imagen para ver si existe
		const img = new Image();
		img.onload = () => {
			this.pathLogo = logoTema;
		};
		img.onerror = () => {
			this.pathLogo = BASE_LOGO_PATH + DEFAULT_LOGO;
		};
		img.src = logoTema;

		this.authStoreService.cargarTema(tema);
	}

	public capturarPagina() {
		const element = document.body; // o algún contenedor específico
		html2canvas(element, {
		  scrollY: -window.scrollY, // para evitar que solo capture lo visible
		  windowWidth: document.documentElement.scrollWidth,
		  windowHeight: document.documentElement.scrollHeight,
		  ignoreElements: (el) => el.classList.contains('ca-footer')
		}).then(canvas => {
		  const link = document.createElement('a');
		  link.download = 'captura-pagina.png';
		  link.href = canvas.toDataURL('image/png');
		  link.click();
		});
	}
}
